export const baseUrl = "https://jsonplaceholder.typicode.com";
export const BASE_URL_STAGING = "https://api.mundotango.trangotechdevs.com/"
export const BASE_URL_STAGINGHTTP = "https://api.mundotango.life/api"
export const CHAT_PORTURL = 'http://buildmate.trangotechdevs.com:3014/api/v1/'
export const INITIAL_TOKEN = "miyqggucnmhijwlbweoanucplvxmezcq"
export const BASE_URL = "https://api.buildmaterentals.com/api/v1/";
